import { Box, Text } from '@chakra-ui/react';
import { Alert, Notification } from '@whitbread-eos/atoms';
import { useStaticHotelInformation } from '@whitbread-eos/utils';
import { useTranslation } from 'next-i18next';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export var SoldOutNotification = _ref => {
  var _data$hotelAvailabili, _data$hotelAvailabili2;
  var hotelAvailabilityResponse = _ref.hotelAvailabilityResponse,
    isHotelOpeningSoon = _ref.isHotelOpeningSoon;
  var _useStaticHotelInform = useStaticHotelInformation(),
    name = _useStaticHotelInform.name;
  var _useTranslation = useTranslation(['common']),
    t = _useTranslation.t;
  var isLoading = hotelAvailabilityResponse.isLoadingHotelAvailability;
  var isError = hotelAvailabilityResponse.isErrorHotelAvailability;
  var error = hotelAvailabilityResponse.errorHotelAvailability;
  var data = hotelAvailabilityResponse.dataHotelAvailability;
  var isAvailable = (data === null || data === void 0 || (_data$hotelAvailabili = data.hotelAvailability) === null || _data$hotelAvailabili === void 0 ? void 0 : _data$hotelAvailabili.available) && (data === null || data === void 0 || (_data$hotelAvailabili2 = data.hotelAvailability) === null || _data$hotelAvailabili2 === void 0 ? void 0 : _data$hotelAvailabili2.roomRates.length) > 0;
  if (isLoading) {
    return _jsx(_Fragment, {});
  }
  if (isError) {
    return _jsx(Text, {
      children: error.message
    });
  }
  if (!isHotelOpeningSoon && isAvailable || isHotelOpeningSoon) {
    return null;
  }
  return _jsx(Box, {
    mt: {
      base: 'md',
      lg: '6'
    },
    "data-testid": "soldout-notification",
    children: _jsx(Notification, {
      title: "",
      description: "".concat(name, " ").concat(t('hoteldetails.unavailableText')),
      status: "info",
      variant: "alert",
      svg: _jsx(Alert, {}),
      maxW: {
        base: 'full'
      },
      lineHeight: "2",
      prefixDataTestId: "soldout-notification"
    })
  });
};